module.exports = __webpack_public_path__ + "img/Middle-Horizontal-Rectangular-Attachment-35.56b39a6b.png";